var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stats)?_c('StandardChart',{attrs:{"input":_vm.chartData,"legend":true}},[_c('v-card-text',[_c('div',[_vm._v("Claimed: "+_vm._s(_vm.claimed)+". Used: "+_vm._s(_vm.applied))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }